export const TranslationsTE = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'ఆన్‌లైన్‌లో ఆర్డర్ చేయండి',
        cart: 'బండి',
        open_24: '24 గంటలు',
        closed: 'మూసివేయబడింది',
        free: 'ఉచిత',
        something_went_wrong: 'ఏదో తప్పు జరిగింది',
        try_again: 'మళ్ళీ ప్రయత్నించండి',
    },
    constants: {
        calendar: {
            days: {
                monday: 'సోమవారం',
                tuesday: 'మంగళవారం',
                wednesday: 'బుధవారం',
                thursday: 'గురువారం',
                friday: 'శుక్రవారం',
                saturday: 'శనివారం',
                sunday: 'ఆదివారం',
            },
        },
        services: {
            pickup: 'పికప్',
            delivery: 'డెలివరీ',
            dine_in: 'డైన్-ఇన్',
            table_booking: 'టేబుల్ బుకింగ్',
        },
        payment: {
            method: {
                cash: 'క్యాష్',
                card: 'కార్డ్',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'క్యాష్',
                card: 'కార్డ్',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'విజయం',
                pending: 'పెండింగ్‌లో ఉంది',
                error: 'లోపం',
                refunded: 'వాపసు ఇచ్చారు',
                refunding: 'వాపసు ఇవ్వడం',
                partial_refunded: 'పాక్షికంగా వాపసు చేయబడింది',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'తొలగించు',
                drop_here: 'మీ ఫైల్‌లను ఇక్కడ వదలండి లేదా ఒకదాన్ని ఎంచుకోవడానికి క్లిక్ చేయండి',
                accepts: '{{fileTypes}} ఫైల్‌లను అంగీకరిస్తుంది',
                errors: {
                    max_files: 'గరిష్టంగా {{number}} అనుమతించబడింది',
                    max_size: 'గరిష్ట ఫైల్ పరిమాణం {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'దుకాణం ప్రస్తుతం మూసివేయబడింది మరియు డైన్-ఇన్ ఆర్డర్ ఇప్పుడే చేయబడలేదు. మీరు దాదాపు తేదీ మరియు సమయం కొరకు ఆర్డర్ చేయడానికి ప్రయత్నించండి',
            },
            buttons: {
                order: {
                    book_order: 'ఆన్‌లైన్‌లో టేబుల్ / ఆర్డర్ బుక్ చేయండి',
                    order_online: 'ఆన్‌లైన్‌లో ఆర్డర్ చేయండి',
                    book_table: 'ఒక టేబుల్ బుక్ చేయండి',
                    order: 'ఆర్డర్ చేయండి',
                    book: 'పుస్తకం',
                    cart: 'బండి',
                    restart: 'పునఃప్రారంభించండి',
                    closed: 'దుకాణం మూసివేయబడింది',
                    not_accepting: 'ఆర్డర్‌లను అంగీకరించడం లేదు',
                },
            },
        },
        modals: {
            auth: {
                login: 'లాగిన్ చేయండి',
                register: 'నమోదు చేసుకోండి',
                register_commence: 'కొనసాగించు',
                register_complete: 'ఖాతాను సృష్టించండి',
                register_confirmation_sent: 'నిర్ధారణ కోడ్ మీ ఇమెయిల్ చిరునామాకి పంపబడింది. దయచేసి దానిని కొనసాగించడానికి క్రిందికి ఇవ్వండి',
                register_confirmation_resent: 'నిర్ధారణ కోడ్ మళ్లీ పంపబడింది, మీ స్పామ్ లేదా పునఃప్రారంభించడానికి చూడండి',
                register_restart: 'పునఃప్రారంభించండి',
                register_resend_code: 'కోడ్‌ని మళ్లీ పంపండి',
                register_confirmation_code_subject: 'ఇ-మెయిల్ నిర్ధారణ కోడ్',
                register_confirmation_code_email: 'మీ ఇమెయిల్ నిర్ధారణ కోడ్ {{confirmation_code}} (24 గంటల్లో గడువు ముగుస్తుంది)',
                login_placeholder: 'ఇ-మెయిల్',
                password_placeholder: 'పాస్వర్డ్',
                confirm_password_placeholder: 'పాస్‌వర్డ్‌ని నిర్ధారించండి',
                confirmation_code_placeholder: 'ఇ-మెయిల్ నిర్ధారణ కోడ్',
                accept_terms: 'నిబంధనలు & షరతులను ఆమోదించండి',
                accept_terms_view: 'చూడండి',
                login_facebook: 'Facebookతో లాగిన్ చేయండి',
                login_google: 'Googleతో లాగిన్ చేయండి',
                benefits: 'మీ ఆర్డర్‌లన్నింటినీ సేవ్ చేయడానికి లాగిన్ చేయండి లేదా ఖాతాను సృష్టించండి',
                logged_in: 'విజయవంతంగా లాగిన్ చేయబడింది',
                logged_out: 'లాగ్ అవుట్ చేసారు',
                password_reset: {
                    init_button: 'పాస్‌వర్డ్ రీసెట్ మెయిల్ పంపండి',
                    init_success: 'పాస్‌వర్డ్ రీసెట్ లింక్ మీ ఇ-మెయిల్‌కి పంపబడింది',
                    complete_button: 'పాస్‌వర్డ్‌ని రీసెట్ చేయండి',
                    complete_success: 'పాస్‌వర్డ్ విజయవంతంగా రీసెట్ చేయబడింది, మీ కొత్త పాస్‌వర్డ్‌తో లాగిన్ చేయండి',
                    forgot_password_text: 'మీ పాస్‌వర్డ్ మర్చిపోయారా?',
                    forgot_password_link: 'పాస్వర్డ్ను రీసెట్ చేయండి',
                    remember_password_text: 'మీ పాస్‌వర్డ్ గుర్తుందా?',
                    remember_password_link: 'వెనక్కి వెళ్ళు',
                    invalid_title: 'పాస్‌వర్డ్ రీసెట్ చెల్లదు',
                    invalid_description: 'ఈ పాస్‌వర్డ్ రీసెట్ లింక్ చెల్లదు, బదులుగా కొత్తదాన్ని అభ్యర్థించండి',
                    invalid_link: 'లాగిన్‌కి వెళ్లండి',
                    title: 'పాస్వర్డ్ రీసెట్',
                    description: 'మీ ఖాతా కోసం కొత్త పాస్‌వర్డ్‌ను నమోదు చేయండి',
                },
                error_generic: 'ఏదో తప్పు జరిగింది, దయచేసి మళ్లీ ప్రయత్నించండి లేదా మమ్మల్ని సంప్రదించండి',
                error_accept_terms: 'దయచేసి నిబంధనలు & షరతులను అంగీకరించండి',
                error_password_length: 'పాస్‌వర్డ్ కోసం కనీసం 6 అక్షరాలు',
                error_social: 'ఏదో తప్పు జరిగింది, మళ్లీ ప్రయత్నించండి లేదా మమ్మల్ని సంప్రదించండి',
                error_confirmation_code: 'చెల్లని నిర్ధారణ కోడ్',
                error_invalid_code: 'చెల్లని నిర్ధారణ కోడ్',
                error_exists: 'వినియోగదారు ఇప్పటికే ఉన్నారు',
                error_invalid_email_pass: 'చెల్లని ఇమెయిల్ చిరునామా లేదా పాస్‌వర్డ్',
                error_password_no_match: 'పాస్‌వర్డ్‌లు ఒకదానికొకటి సరిపోలడం లేదు',
                error_user_not_found: 'ఆ ఇమెయిల్ చిరునామాతో వినియోగదారు లేరు',
                error_invalid_email: 'చెల్లని ఇమెయిల్ చిరునామా',
                error_invalid_reset_token: 'చెల్లని రీసెట్ లింక్, మరొక దానిని అభ్యర్థించండి',
            },
            booking: {
                form: {
                    name: 'పూర్తి పేరు',
                    email: 'ఇ-మెయిల్ చిరునామా',
                    phone: 'ఫోన్ నంబర్',
                    number_of_people: 'వ్యక్తుల సంఖ్య',
                    number_of_people_max: 'వ్యక్తుల సంఖ్య ({{max_people}} గరిష్టంగా)',
                    number_of_people_min: 'వ్యక్తుల సంఖ్య ({{min_people}} నిమి)',
                    number_of_people_max_min: 'వ్యక్తుల సంఖ్య ({{min_people}} నుండి {{max_people}} మధ్య)',
                    notes: 'గమనికలు / ప్రత్యేక అభ్యర్థనలు',
                    submit: 'బుకింగ్ అభ్యర్థనను సమర్పించండి',
                    email_optional: '(ఐచ్ఛికం)',
                    date: 'తేదీ',
                    duration: 'వ్యవధి',
                    seating: 'అందుబాటులో ఉన్న సమయాలు',
                    number_of_guests: 'అతిథుల సంఖ్య',
                    notes_placeholder: 'అలెర్జీలు, సందర్భం, సీటు ప్రాధాన్యత',
                    reserving: 'రిజర్వ్ అవుతోంది...',
                    reserve_table: 'టేబుల్ బుక్ చేయండి',
                    please_choose_a_date_and_time: 'దయచేసి తేదీ మరియు సమయాన్ని ఎంచుకోండి.',
                    invalid_people: 'వ్యక్తుల సంఖ్య {{min}} నుండి {{max}} మధ్య ఉండాలి.',
                    party_size_max_fallback: 'అనుమతించిన గరిష్టం',
                    loading_available_times: 'అందుబాటులో ఉన్న సమయాలు లోడ్ అవుతున్నాయి…',
                    select_a_date_to_see_available_times: 'అందుబాటులో ఉన్న సమయాలు చూడటానికి తేదీని ఎంచుకోండి.',
                    no_times_available_for_this_date: 'ఈ తేదీకి సమయాలు లేవు. దయచేసి మరో రోజు ఎంచుకోండి.',
                    shift: 'షిఫ్ట్',
                    service_times: 'సేవా సమయాలు',
                    new_shift: 'కొత్త షిఫ్ట్',
                    time: 'సమయం',
                    times: 'సమయాలు',
                    unavailable: 'అందుబాటులో లేదు',
                    available: 'అందుబాటులో ఉంది',
                    required_name: 'దయచేసి మీ పేరు నమోదు చేయండి.',
                    required_phone: 'దయచేసి మీ ఫోన్ నంబర్ నమోదు చేయండి.',
                    required_email: 'దయచేసి మీ ఇమెయిల్ నమోదు చేయండి.',
                    invalid_email: 'దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్ నమోదు చేయండి.',
                    required_terms: 'బుక్ చేయడానికి ముందు నిబంధనలను అంగీకరించండి.',
                    reservation_is_unavailable: 'రిజర్వేషన్ అందుబాటులో లేదు.',
                    please_contact_the_restaurant_directly: 'దయచేసి రెస్టారెంట్‌ను నేరుగా సంప్రదించండి.',
                    almost_done: 'దాదాపు పూర్తయింది',
                    your_details: 'మీ వివరాలు',
                    tell_us_who_s_coming: 'మీ రిజర్వేషన్‌ను నిర్ధారించేందుకు ఎవరు వస్తున్నారో చెప్పండి.',
                    book_your_table: 'మీ టేబుల్ బుక్ చేయండి',
                    choose_a_time_that_works_for_you: 'మీకు సరిపడే సమయాన్ని ఎంచుకోండి.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'మీ బుకింగ్ అభ్యర్థన పంపండి, మిగతాది రెస్టారెంట్ చూసుకుంటుంది.',
                    select_date: 'తేదీ ఎంచుకోండి',
                    standard: 'ప్రామాణికం',
                    minutes: 'నిమిషాలు',
                    next: 'తదుపరి →',
                    back: '← వెనుకకు',
                    accept_terms: 'నేను నిబంధనలు మరియు షరతులను అంగీకరిస్తున్నాను.',
                    info_1: 'మీ బుకింగ్ ఆమోదించబడినప్పుడు లేదా తిరస్కరించబడినప్పుడు మీరు ఇ-మెయిల్ నోటిఫికేషన్‌ను అందుకుంటారు',
                },
                errors: {
                    not_found: "బుకింగ్ ఉండదు. ఇది అనుమతించబడలేదు లేదా తప్పిపోయారు",
                    generic: 'ఏదో తప్పు జరిగింది, పేజీని రిఫ్రెష్ చేయండి లేదా మమ్మల్ని సంప్రదించండి',
                    something_went_wrong: 'ఏదో తప్పు జరిగింది',
                    accept_terms: 'దయచేసి నిబంధనలు & షరతులను అంగీకరించండి',
                    required_phone: 'దయచేసి మీ ఫోన్ నంబర్‌ను నమోదు చేయండి',
                    required_email: 'దయచేసి మీ ఇమెయిల్‌ని నమోదు చేయండి',
                    required_zip: 'దయచేసి మీ బిల్లింగ్ జిప్ కోడ్‌ని నమోదు చేయండి',
                    required_name: 'దయచేసి మీ పేరును నమోదు చేయండి',
                    invalid_email: 'దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామాను నమోదు చేయండి',
                    invalid_phone: 'దయచేసి చెల్లుబాటు అయ్యే ఫోన్ నంబర్‌ను నమోదు చేయండి',
                    invalid_people: 'చెల్లని వ్యక్తుల సంఖ్య',
                    missing_custom_fields: 'దయచేసి అవసరమైన అన్ని ఫీల్డ్‌లను పూరించండి.',
                    booking_capacity_threshold: 'ఈ సమయానికి మేము నిండిపోయాము. దయచేసి మరో సమయం ప్రయత్నించండి.',
                    slot_unavailable: 'ఈ సంఖ్యకు మేము నిండిపోయాము. దయచేసి మరో సమయం ప్రయత్నించండి.',
                    booking_date_paused: 'ఈ తేదీకి బుకింగ్‌లు నిలిపివేయబడ్డాయి. దయచేసి మరో రోజు ఎంచుకోండి.',
                    invalid_table_assignment: 'ఆ టేబుళ్లలో మీ బృందానికి స్థలం లేదు. దయచేసి మరో సమయం ఎంచుకోండి.',
                    exceeded_order_limit: 'చాలా ఎక్కువ బుకింగ్ అభ్యర్థనలు. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.',
                    validation_failed_recaptcha_v3: 'అసాధారణ ట్రాఫిక్ గుర్తించబడింది. మీరు VPN ఉపయోగిస్తున్నారా? పైన ఉన్న ధృవీకరణ పూర్తి చేసి మళ్లీ ప్రయత్నించండి.',
                    validation_failed_recaptcha_v2: 'బుకింగ్ ప్రారంభించలేకపోయాము. దయచేసి మళ్లీ ప్రయత్నించండి లేదా మరో పద్ధతి ఉపయోగించండి. మీరు VPN ఉపయోగిస్తుంటే, ముందు దాన్ని ఆపండి.',
                    booking_already_exists: 'ఈ రిజర్వేషన్ ఇప్పటికే పంపబడింది. మీ ఇమెయిల్ చూడండి లేదా బుకింగ్ లింక్ తెరవండి.',
                    invalid_party_size: 'దయచేసి చెల్లుబాటు అయ్యే సంఖ్యను ఎంచుకోండి.',
                    invalid_request: 'చెల్లని అభ్యర్థన. దయచేసి పేజీని రిఫ్రెష్ చేసి మళ్లీ ప్రయత్నించండి.',
                    table_booking_unavailable: 'టేబుల్ బుకింగ్ అందుబాటులో లేదు.',
                },
            },
            cart: {
                title: 'బండి',
                proceed_to_checkout: 'చెక్అవుట్ చేయడానికి కొనసాగండి',
                edit_dish: 'సవరించు',
                remove_dish: 'తొలగించు',
                no_items_1: 'కార్ట్‌లో వస్తువులు లేవు',
                no_items_2: 'కొనసాగించడానికి ముందుగా కొన్ని జోడించండి',
                free_delivery_notice: '{{value, currency}} కంటే ఎక్కువ ఆర్డర్‌లకు ఉచిత డెలివరీ',
                errors: {
                    min_order_promo: 'ఈ ప్రోమో వర్తింపజేయడానికి ముందు కనీస కార్ట్ విలువ {{value, currency}} అవసరం',
                    min_order_delivery: 'డెలివరీ కోసం కనీస కార్ట్ విలువ {{value, currency}}',
                },
                promo: {
                    heading: 'ప్రోమో కోడ్',
                    placeholder: 'మీ ప్రోమో కోడ్‌ని నమోదు చేయండి',
                    add: 'కోడ్ జోడించండి',
                    title: 'ప్రోమో {{name}} కార్ట్‌కి జోడించబడింది',
                    fixed_discount: '{{value, currency}} ఆఫ్',
                    percent_discount: '{{value}}% తగ్గింపు',
                    added_to_cart: 'కార్ట్‌కి ప్రోమో జోడించబడింది',
                    errors: {
                        not_found: 'ప్రోమో కనుగొనబడలేదు',
                        disabled: 'ప్రోమో నిలిపివేయబడింది',
                        not_available: 'ప్రోమో ప్రస్తుతం అందుబాటులో లేదు',
                        not_eligible: 'ప్రమోషనల్ కోడ్‌ని వర్తింపజేయడానికి అర్హత లేదు',
                        not_available_time: 'ఈ సారి ప్రోమో వర్తించదు',
                        logged_in_only: 'ఈ ప్రోమోను ఉపయోగించడానికి తప్పనిసరిగా లాగిన్ అయి ఉండాలి',
                        already_used: 'మీరు ఇప్పటికే ఈ ప్రోమోను ఉపయోగించారు',
                        invalid: 'ఈ ప్రోమో ఇకపై చెల్లదు',
                        invalid_service: 'మీరు ఎంచుకున్న సేవకు ఈ ప్రోమో చెల్లదు',
                        later_only: 'ముందస్తు ఆర్డర్‌లకు మాత్రమే చెల్లుబాటు అవుతుంది',
                        now_only: 'తక్షణం చెల్లించాల్సిన ఆర్డర్‌లకు మాత్రమే చెల్లుబాటు అవుతుంది, ముందస్తు ఆర్డర్‌లకు కాదు',
                        generic: 'అయ్యో... ఏదో తప్పు జరిగింది మరియు లాగ్ చేయబడింది',
                        dishes_required_multi: 'మీ కార్ట్‌కి నిర్దిష్ట ఐటెమ్‌లను జోడించినప్పుడు మాత్రమే ఈ ప్రోమో వర్తించబడుతుంది',
                        dishes_required_single: "ఈ ప్రోమో మాత్రమే '{{dish}}' కొరకు వర్తించబడుతుంది",
                    },
                },
                tip: {
                    title: 'ఆర్డర్ చిట్కా',
                    placeholder: 'ఆర్డర్ చిట్కాను జోడించండి',
                },
            },
            free_items_promo: {
                title: 'ఉచిత వస్తువులు',
                usage_confirmation: {
                    question: 'మీరు ఉచిత వస్తువులకు అర్హులు. మీరు వాటిని చూసి జోడించాలనుకుంటున్నారా?',
                    cancellation: "లేదు, నేను ఉచిత వస్తువులను కాలేదు",
                    acceptance: 'అవును',
                },
                free_items_selection: {
                    multiple: {
                        description: '{{number}} ఉచిత వస్తువు(లు)ని ఎంచుకోండి',
                    },
                    single: {
                        description: 'ఉచిత వస్తువును ఎంచుకోండి',
                    },
                    confirm_button: 'నిర్ధారించండి',
                },
            },
            checkout: {
                title: 'చెక్అవుట్',
                subtitle: 'మీ ఆర్డర్ వివరాలను నిర్ధారించండి',
                details: {
                    service: 'సేవ',
                    due: 'కారణంగా',
                    due_now_asap: 'ఇప్పుడు / ASAP',
                    address: 'డెలివరీ చిరునామా',
                    total: 'మొత్తం',
                    table: 'పట్టిక',
                    store_location: 'స్టోర్ చిరునామా',
                },
                customer: {
                    title: 'కస్టమర్',
                    subtitle: 'మీ ఆర్డర్ & వివరాలను సేవ్ చేయడానికి లాగిన్ చేయండి',
                    button: 'లాగిన్ చేయండి',
                    name: 'పూర్తి పేరు',
                    email: 'ఇమెయిల్',
                    phone: 'ఫోన్',
                    phone_important: 'ఫోన్ (ముఖ్యమైనది)',
                    notes: 'ఆర్డర్ నోట్స్',
                    delivery_notes: 'డెలివరీ సూచనలు / ఆర్డర్ నోట్స్',
                    optional: 'ఐచ్ఛికం',
                },
                payment: {
                    title: 'చెల్లింపు విధానం',
                    qr_modal_help: 'మీ {{app}} మొబైల్ అప్లికేషన్‌ను ఉపయోగించి QR ని స్క్యాన్ చేయడంతో ఇన్స్టార్ట్ చేసి ఈ ఆర్డర్ కొరకు చెల్లింపును పూర్తి చేయండి. మీ మొబైల్ అప్లికేషన్‌లో చెల్లింపు పూర్తి అయినప్పుడు, నేను ఈ QR మొబైల్ అప్లికేషన్‌ను మూసివేయవచ్చు. మీరు మీ చెల్లింపు పద్ధతిని పూర్తి చేయనిప్పుడు, దయచేసి ఈ QR మొబైల్ అప్లికేషన్‌ను మూసివేయకోరవచ్చు.',
                    switch_to_app_help: 'క్రింది బటన్ను అచేతనం చేసి, {{app}} మొబైల్ అప్లికేషన్‌ను తెరవడంతో ఇన్స్టార్ట్ చేసి ఈ ఆర్డర్ కొరకు చెల్లింపును పూర్తి చేయండి. మీ మొబైల్ అప్లికేషన్‌లో చెల్లింపు పూర్తి అయినప్పుడు, నేను ఈ మొబైల్ అప్లికేషన్‌ను మూసివేయవచ్చు. మీరు మీ చెల్లింపు పద్ధతిని పూర్తి చేయనిప్పుడు, దయచేసి ఈ మొబైల్ అప్లికేషన్‌ను మూసివేయకోరవచ్చు.',
                    open_app: '{{app}} అప్లికేషన్‌ను తెరవండి',
                    continue: 'కొనసాగించు',
                    continue_to_payment: '{{method}}కి కొనసాగండి',
                    back_to_cart: 'తిరిగి కార్ట్‌కి',
                },
                accept_terms: 'నిబంధనలు & షరతులను ఆమోదించండి',
                accept_terms_view: 'చూడండి',
                processing_order: 'ప్రాసెసింగ్ ఆర్డర్',
                warning: {
                    different_payment_currency: 'దుకాణం విలువలు {{store_currency}}లో ఉన్నాయి కానీ చెల్లింపు విధానం {{payment_currency}}లో ఉన్నాయి',
                    closing_soon: 'త్వరలో మూసివేయబడుతుంది, ఆర్డర్‌లను {{value}} నిమిషాలలోపు చేయాలి',
                    closed: 'క్షమించండి, ఈ సేవ మూసివేయబడింది మరియు ఆర్డర్‌లు ఆమోదించబడవు',
                    paused: 'క్షమించండి, ఈ సేవ పాజ్ చేయబడింది మరియు ప్రస్తుతానికి ఆర్డర్‌లు అంగీకరించబడవు',
                    expired: 'మీరు ఎంచుకున్న సమయంలో మేము ఇకపై మీ ఆర్డర్‌ని పూర్తి చేయలేము. దయచేసి తర్వాత తేదీ లేదా సమయాన్ని ఎంచుకోండి',
                },
                errors: {
                    walletly_promo: 'Walletly ప్రోమోలో లోపం ఉంది, దయచేసి మరొక ప్రోమోని ప్రయత్నించండి!',
                    stripe_generic: 'క్రెడిట్ కార్డ్ లోపం, మళ్లీ ప్రయత్నించండి లేదా మరొక పద్ధతి',
                    validation_failed: 'ఈ సమయంలో ఈ చెల్లింపు ఆమోదించబడదు. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి.',
                    validation_failed_recaptcha_v3: 'అసాధారణ ట్రాఫిక్ గుర్తించబడింది. మీరు VPN ఉపయోగిస్తున్నారా? దయచేసి పై సవాలును పూర్తి చేసి, మళ్లీ ప్రయత్నించండి.',
                    validation_failed_recaptcha_v2: 'మేము చెల్లింపును ప్రారంభించలేకపోయాము. దయచేసి మళ్లీ ప్రయత్నించండి లేదా మరొక పద్ధతిని ఉపయోగించండి. మీరు VPNని ఉపయోగిస్తుంటే, ముందుగా దాన్ని ఆఫ్ చేయడానికి ప్రయత్నించండి.',
                    stripe_loading_fail: 'చెల్లింపు ఫారమ్‌ను లోడ్ చేయడంలో లోపం ఏర్పడింది, దయచేసి మళ్లీ ప్రయత్నించండి',
                    something_went_wrong: 'ఏదో తప్పు జరిగింది',
                    paypal_generic: 'PayPalలో ఏదో తప్పు జరిగింది, మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_fail: 'చెల్లింపు విఫలమైంది, దయచేసి మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_cancelled: 'చెల్లింపు రద్దు చేయబడింది, దయచేసి మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_error: 'ఆన్‌లైన్ చెల్లింపును ప్రాసెస్ చేయడంలో లోపం ఏర్పడింది, మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_declined: 'మీ చెల్లింపు పద్ధతి తిరస్కరించబడింది',
                    card_declined: "Your card was declined and payment couldn't be processed",
                    promo_max_uses_exceeded: "ఈ ప్రోమో కోడ్ దాని వినియోగ పరిమితిని చేరుకుంది మరియు ఇకపై అందుబాటులో లేదు.",
                    store_closed: 'స్టోర్ మూసివేయబడింది మరియు ఇకపై ఆర్డర్‌లను అంగీకరించడం లేదు',
                    accept_terms: 'దయచేసి నిబంధనలు & షరతులను అంగీకరించండి',
                    required_payment: 'దయచేసి చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    required_phone: 'దయచేసి మీ ఫోన్ నంబర్‌ను నమోదు చేయండి',
                    required_email: 'దయచేసి మీ ఇమెయిల్‌ని నమోదు చేయండి',
                    required_zip: 'దయచేసి మీ బిల్లింగ్ జిప్ కోడ్‌ని నమోదు చేయండి',
                    required_name: 'దయచేసి మీ పేరును నమోదు చేయండి',
                    invalid_email: 'దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామాను నమోదు చేయండి',
                    invalid_phone: 'దయచేసి చెల్లుబాటు అయ్యే ఫోన్ నంబర్‌ను నమోదు చేయండి',
                    invalid_cc_number: 'మీ క్రెడిట్ కార్డ్ నంబర్ చెల్లదు',
                    invalid_order_amount: 'ఈ చెల్లింపు పద్ధతికి అవసరమైన కనీస మొత్తం',
                    retry_cc_number: 'ఏదో తప్పు జరిగింది, మీ క్రెడిట్ కార్డ్ నంబర్‌ని మళ్లీ నమోదు చేసి, మళ్లీ ప్రయత్నించండి',
                    closed: 'స్టోర్ మూసివేయబడింది మరియు ఆర్డర్‌లను అంగీకరించడం లేదు',
                    promo_login_required: 'ఈ ప్రోమోను ఉపయోగించడానికి తప్పనిసరిగా లాగిన్ అయి ఉండాలి',
                    promo_used: 'మీరు ఇప్పటికే ఈ ప్రోమోను ఉపయోగించారు',
                    promo_by_payment_method_not_applicable: 'ఎంచుకున్న చెల్లింపు పద్ధతికి ప్రోమో వర్తించదు.',
                    missing_custom_checkout_fields: 'దయచేసి అవసరమైన అన్ని ఫీల్డ్‌లను పూరించండి.',
                    delivery_unavailable: 'ప్రస్తుతం డెలివరీ సేవ అందుబాటులో ఉండకపోవచ్చు. దయచేసి బదులుగా పికప్ ఆర్డర్ చేయాలని పరిగణించండి.',
                    required_delivery_provider: 'దయచేసి సర్వీస్ డెలివరీని ఎంచుకోండి.',
                    required_delivery_quotation: 'డెలివరీ అంచనా గడువు ముగిసింది.',
                    exceeded_order_limit: 'ప్రస్తుతం మాకు చాలా ఆర్డర్‌లు వస్తున్నాయి. దయచేసి తర్వాత సమయాన్ని ఎంచుకోండి.',
                    exceeded_order_limit_later: 'మీరు ఎంచుకున్న సమయంలో మేము ఇకపై మీ ఆర్డర్‌ని పూర్తి చేయలేము. దయచేసి తర్వాత తేదీ లేదా సమయాన్ని ఎంచుకోండి',
                },
                button: {
                    continue: 'చెల్లింపును కొనసాగించండి',
                    place_order: 'ఆర్డర్ ఉంచండి',
                    update_order: 'ఆర్డర్‌ని నవీకరించండి',
                },
                delivery_estimation: {
                    title: 'డెలివరీ అంచనా',
                    details: {
                        provider: 'డెలివరీ ప్రొవైడర్',
                        estimated_fee: 'అంచనా రుసుము',
                        estimated_total_fee: 'డెలివరీ ఫీజు మొత్తం',
                        estimated_discount_fee: 'డెలివరీ రుసుము తగ్గింపు',
                        previous_estimated_fee: 'మునుపటి అంచనా రుసుము',
                        tips: 'చిట్కాలు',
                        estimated_delivery_time: 'అంచనా వేసిన డెలివరీ సమయం',
                        uber_new_estimation: 'కొత్త అంచనాను అభ్యర్థించండి',
                        uber_new_estimation_success: 'కొత్త Uber డెలివరీ అంచనా వర్తింపజేయబడింది.',
                        uber_estimation_expired: 'డెలివరీ అంచనా గడువు ముగిసింది',
                        uber_price: 'మేము Uber ధరను కలిగి ఉన్నాము',
                        uber_need_time: 'నాకు మరింత సమయం కావాలి',
                        lalamove_price: 'మేము లాలామోవ్ డెలివరీ రుసుమును కలిగి ఉన్నాము',
                        lalamove_new_estimation_success: 'కొత్త లాలాల్మోవ్ డెలివరీ అంచనా వర్తింపజేయబడింది.',
                        lalamove_estimation_expired: 'డెలివరీ అంచనా గడువు ముగిసింది',
                        lalamove_need_time: 'నాకు మరింత సమయం కావాలి',
                        lalamove_new_estimation: 'కొత్త అంచనాను అభ్యర్థించండి',
                    },
                    quotation_error: 'డెలివరీ అంచనాను గణించడంలో ఏదో తప్పు జరిగింది.',
                },
            },
            customer: {
                age_v: {
                    title: 'వయస్సు ధృవీకరణ',
                    required_for_items: 'కొన్ని వస్తువులను ఆర్డర్ చేయడం అవసరం',
                    min_age: 'కనీస వయస్సు: {{age}} సంవత్సరాలు',
                    est_time: 'అంచనా వేయబడిన ధృవీకరణ సమయం: {{time}} గంటలు',
                    upload_description: 'ధృవీకరణకు క్రిందికి మీ IDని అప్‌లోడ్ చేయండి. ధృవీకరించినప్పుడు మీరు ఇమెయిల్ ద్వారా తెలుసుకోవచ్చు. అప్‌లోడ్ చేయడానికి గరిష్ఠ 2 MB పెద్దది గల 2 బీమ్స్ అప్‌లోడ్ చేయండి',
                    pending_description_1: 'మీ పత్రాలను సమర్పించడానికి ధన్యవాదాలు. మీరు ఆమోదించబడినప్పుడు మీరు ఇమెయిల్ ద్వారా తెలుసుకోవచ్చు',
                    pending_description_2: 'ధృవీకరణ స్థితిని నవీకరించడానికి పేజీని రీఫ్రీష్ చేయండి. అంచనా ధృవీకరణ సమయం {{time}} గంటలు',
                    approved_description: 'మీ ఖాతా ధృవీకరించబడింది మరియు మీరు పరిమితం చేయబడిన మెనుల నుండి ఆర్డర్ చేయవచ్చు',
                    rejected_description: 'మీ ID తిరస్కరించబడింది. మీరు మళ్లీ ప్రయత్నించాలనుకుంటే, దయచేసి మీ IDని మళ్లీ అప్‌లోడ్ చేయండి',
                    upload: 'అప్‌లోడ్ చేయండి',
                    reupload: 'పత్రాలను మళ్లీ అప్‌లోడ్ చేయండి',
                    go_back: 'వెనక్కి వెళ్ళు',
                    view_document: 'పత్రాన్ని వీక్షించండి {{number}}',
                    status: {
                        unverified: 'ధృవీకరించబడలేదు',
                        pending: 'ఆమోదం కోసం వేచి ఉంది',
                        approved: 'విజయవంతంగా ధృవీకరించబడింది',
                        rejected: 'తిరస్కరించబడింది',
                    },
                },
                headings: {
                    sessions: 'సెషన్స్',
                    orders: 'ఆర్డర్ చేయండి',
                    spend: 'ఖర్చు పెట్టండి',
                    order_history: 'ఆర్డర్ చరిత్ర',
                    loyalty: 'విధేయత',
                    loyalty_points: 'లాయల్టీ పాయింట్లు',
                    added: 'ప్రోమో జోడించబడింది.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'దయచేసి రీడీమ్ చేయడానికి ముందు ఏదైనా అంశాన్ని ఎంచుకోండి!',
                    not_found: 'ప్రోమో కనుగొనబడలేదు!',
                    already_exists: 'ప్రోమో ఇప్పటికే ఉంది!',
                    try_again: 'ఈ ఒప్పందాన్ని వర్తింపజేయలేరు. దయచేసి మళ్లీ ప్రయత్నించండి!',
                },
            },
            custom_payment: {
                title: '{{name}} చెల్లింపు ఫారమ్',
                description: 'మీరు మేమారు ఆన్లైన్ చెల్లింపు ఫారమ్కి వచ్చారు. దయచేసి క్రింది ప్రాంతాలను పూర్తి చేయడంతో చెల్లింపు చేయండి. ఒక మొత్తం ఇవ్వబడదు అయినప్పుడు, మీ వివరాలు సేవ్ చేయబడింది కానీ మీరు చార్జ్ చేయబడలేరు.',
                disabled: 'ఈ ఆన్లైన్ చెల్లింపు పేజీ సరిగా సంరక్షించబడదు. దయచేసి సమస్యను సరిచేయడానికి సైట్ ఆయంతికుడు కాన్టాక్ట్ చేయండి.',
                success: 'మీ చెల్లింపు విజయవంతంగా ప్రాసెస్ చేయబడింది మరియు మీ వివరాలు సేవ్ చేయబడ్డాయి. ధన్యవాదాలు',
                back: 'ఇంటికి తిరిగి వెళ్ళు',
                fields: {
                    name: 'పూర్తి పేరు',
                    email: 'ఇ-మెయిల్ చిరునామా',
                    reference: 'చెల్లింపు Ref.',
                    amount: 'మొత్తం ($)',
                    name_on_card: 'కార్డ్‌లో పేరు',
                    submit: 'చెల్లింపును సమర్పించండి',
                },
                warning: {
                    currency: 'గమనిక: {{actual}}లో చెల్లింపు మొత్తం, {{default}} కాదు',
                },
                errors: {
                    generic: 'ఏదో తప్పు జరిగింది, మళ్లీ ప్రయత్నించండి లేదా మమ్మల్ని సంప్రదించండి',
                    stripe_generic: 'క్రెడిట్ కార్డ్ లోపం, పేజీని రిఫ్రెష్ చేసి, మళ్లీ ప్రయత్నించండి',
                    payment_fail: 'చెల్లింపు విఫలమైంది, దయచేసి మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_cancelled: 'చెల్లింపు రద్దు చేయబడింది, దయచేసి మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_error: 'ఆన్‌లైన్ చెల్లింపును ప్రాసెస్ చేయడంలో లోపం ఏర్పడింది, మళ్లీ ప్రయత్నించండి లేదా మరొక చెల్లింపు పద్ధతిని ఎంచుకోండి',
                    payment_declined: 'మీ చెల్లింపు పద్ధతి తిరస్కరించబడింది',
                    card_declined: "మీ కార్డు తిరస్కరించబడింది మరియు చెల్లింపును ప్రాసెస్ చేయడం సాధ్యపడలేదు.",
                    promo_max_uses_exceeded: "ఈ ప్రోమో కోడ్ దాని వినియోగ పరిమితిని చేరుకుంది మరియు ఇకపై అందుబాటులో లేదు.",
                },
            },
            dish: {
                add: 'కార్ట్‌కు జోడించండి',
                edit: 'అంశాన్ని నవీకరించండి',
                notes: 'ప్రత్యేక సూచనలు...',
                ingredients: {
                    title: 'కావలసినవి',
                    uncheck_remove: 'తీసివేయడానికి అన్-చెక్ చేయండి',
                },
                ingredients_title: 'కావలసినవి',
                combo: {
                    choose_dish: 'ఒక అంశాన్ని ఎంచుకోండి',
                },
                option_sets: {
                    conditions: {
                        select_one: 'ఒకదాన్ని ఎంచుకోండి (అవసరం)',
                        select_one_optional: 'ఒకదాన్ని ఎంచుకోండి (ఐచ్ఛికం)',
                        select_between: '{{min}} - {{max}} మధ్య ఎంచుకోండి (అవసరం)',
                        select_at_least: 'కనీసం {{qty}} (అవసరం) ఎంచుకోండి',
                        select_up_to: '{{qty}} వరకు ఎంచుకోండి (ఐచ్ఛికం)',
                        select_multiple_optional: 'బహుళ ఎంచుకోండి (ఐచ్ఛికం)',
                        select_multiple: 'బహుళ ఎంచుకోండి (అవసరం)',
                        free_amount: 'మొదటి {{qty}} ఉచితం / {{selected}} ఎంచుకోబడింది',
                    },
                    points: {
                        none_consumed: 'మీరు గరిష్టంగా {{maxFree}} ఎంపికలను ఉచితంగా ఎంచుకోవచ్చు',
                        less_than_total_points: 'మీరు ఉచితంగా మరిన్ని ఎంపికలను ఎంచుకోవచ్చు',
                        greather_than_total_points: 'మీరు అదనపు ఛార్జీ కోసం మరిన్ని ఎంపికలను ఎంచుకోవచ్చు',
                    },
                },
                error: 'దయచేసి ఎరుపు రంగులో గుర్తించబడిన ఏవైనా ఎంపికలను సరిచేయండి',
                added_to_cart: 'అంశం కార్ట్‌కు జోడించబడింది',
            },
            map: {
                zone_fee: 'డెలివరీ రుసుము',
                view_in_google: 'Google మ్యాప్స్‌లో వీక్షించండి',
            },
            portal_go_back: {
                title: 'రెస్టారెంట్ శోధనకు తిరిగి వెళ్లాలా?',
                description: 'మీ కార్ట్‌లోని ఏవైనా వస్తువులు పోతాయి',
                cancel: 'రద్దు చేయి',
                proceed: 'వెనక్కి వెళ్ళు',
            },
            order: {
                config: {
                    services: {
                        title: 'సేవను ఎంచుకోండి',
                        table_booking: 'బుక్ టేబుల్',
                    },
                    address_custom: {
                        input_placeholder: 'మీ చిరునామాను నమోదు చేయండి',
                    },
                    address: {
                        input_placeholder: 'మీ డెలివరీ చిరునామాను కనుగొనండి',
                        extras_placeholder: 'యూనిట్ నంబర్, భవనం పేరు, డెలివరీ సూచనలు మొదలైనవి...',
                        search_placeholder: 'మీ చిరునామా కోసం శోధించండి',
                        search_input_placeholder: 'శోధించడానికి టైప్ చేయండి',
                        no_address_found: 'చిరునామాలు ఏవీ కనుగొనబడలేదు. 5 కంటే ఎక్కువ అక్షరాలను టైప్ చేయడానికి ప్రయత్నించండి',
                        not_found: 'డెలివరీ చిరునామా కనుగొనబడలేదు లేదా చెల్లదు, మళ్లీ ప్రయత్నించండి',
                        not_delivering: 'మేము ప్రస్తుతం ఈ చిరునామాకు బట్వాడా చేయడం లేదు',
                        not_in_range: 'మీ చిరునామా మా స్టోర్ లొకేషన్ పరిధిలో లేదు',
                        not_in_zone: 'మీ చిరునామా యాక్టివ్ డెలివరీ జోన్‌లో లేదు',
                        no_number: 'మీ చిరునామా తప్పనిసరిగా వీధి నంబర్‌ను కలిగి ఉండాలి',
                        location_permission: 'మీ ప్రస్తుత స్థానాన్ని యాక్సెస్ చేయడానికి ఈ వెబ్‌సైట్‌ను అనుమతించాలా?',
                        location_permission_warning: "మీ ప్రస్తుత స్థలాన్ని యాక్సెస్ చేయడం సాధ్యం కాలేదు. దయచేసి మీ పరికరం మరియు వెబ్ బ్రౌజర్‌లో లోకేషన్ సర్వీస్‌ను (స్థాన సేవలను) ప్రారంభించండి. ఇక్కడ కొన్ని సూచనలు ఉన్నాయి:",
                        pick_location: 'మీ స్థానాన్ని ఎంచుకోండి',
                        pick_location_help_text: 'మ్యాప్‌లో స్థానాన్ని ఎంచుకోవడానికి మార్కర్‌ను లాగండి.',
                        use_current_location: 'ప్రస్తుత స్థానాన్ని ఉపయోగించండి',
                        locate_on_map: 'మ్యాప్‌లో గుర్తించండి',
                    },
                    datetime: {
                        title: 'మీరు మీ ఆర్డర్‌ను ఎప్పుడు ఇష్టపడతారు',
                        due_now: 'ఇప్పుడు',
                        due_later: 'తరువాత',
                        service_not_available: 'క్షమించండి, మేము ప్రస్తుతం {{service}} కోసం ఆర్డర్‌లను అంగీకరించడం లేదు.',
                        currently_closed: '{{service}} ప్రస్తుతం మూసివేయబడింది కానీ మీరు తర్వాత ఆర్డర్ చేయవచ్చు',
                        due_unavailable: 'అందుబాటులో లేదు',
                        due_closed: 'మూసివేయబడింది',
                        select_date: 'తేదీని ఎంచుకోండి',
                        select_time: 'సమయాన్ని ఎంచుకోండి',
                        select_order_date: 'మీ ఆర్డర్ తేదీని ఎంచుకోండి',
                        select_order_time: 'మీ ఆర్డర్ సమయాన్ని ఎంచుకోండి',
                        select_order_date_time: 'మీ ఆర్డర్ తేదీ/సమయాన్ని ఎంచుకోండి',
                        select_booking_date: 'మీ బుకింగ్ తేదీని ఎంచుకోండి',
                        select_booking_time: 'మీ బుకింగ్ సమయాన్ని ఎంచుకోండి',
                        no_times_available: 'ఎంచుకోవడానికి సమయాలు అందుబాటులో లేవు',
                        date_today: '(ఈరోజు)',
                        date_closed: '(మూసివేయబడింది)',
                        date_bookings_paused: '(బుకింగ్‌లు నిలిపివేయబడ్డాయి)',
                        time_slot_closed: 'మూసివేయబడింది',
                    },
                    number_of_people: {
                        placeholder: 'వ్యక్తుల సంఖ్య',
                    },
                    table: {
                        select: 'పట్టికను ఎంచుకోండి',
                        select_popup_title: 'మీ టేబుల్‌ని ఎంచుకోండి',
                        password: 'టేబుల్ పాస్వర్డ్',
                        password_warning: 'కొనసాగించడానికి మీ టేబుల్ పాస్‌వర్డ్‌ను నమోదు చేయండి',
                    },
                    warning: {
                        closed: 'క్షమించండి, మేము ప్రస్తుతం మూసివేయబడ్డాము / ఏ ఆర్డర్‌లను అంగీకరించడం లేదు',
                        not_available: 'క్షమించండి, మేము ప్రస్తుతం ఏ ఆర్డర్‌లను అంగీకరించడం లేదు',
                    },
                    eta: {
                        delivery: `అంచనా వేసిన డెలివరీ సమయం సుమారు {{minutesToCustomer}} నిమిషాలు`,
                        pickup: `సుమారు {{minutesToCustomer}} నిమిషాలలో ఆర్డర్ సిద్ధంగా ఉంటుంది`,
                    },
                    start_button: 'ఆర్డర్ ప్రారంభించండి',
                },
                history: {
                    invalid: 'కొన్ని అంశాలు ఆర్డర్ చేసినప్పుడు మారింది లేదా ఇంకా లేదు కాబట్టి మళ్లీ ఆర్డర్ చేయడానికి పరికరంగా లేవు',
                },
                reorder: {
                    title: 'త్వరిత రీ-ఆర్డర్',
                    description: 'మీ మునుపటి ఆర్డర్‌ల నుండి వస్తువులను సులభంగా ఆర్డర్ చేయండి',
                },
            },
            receipt: {
                errors: {
                    not_found: 'ఆర్డర్ కనుగొనబడలేదు, పేజీని రిఫ్రెష్ చేసి, మళ్లీ ప్రయత్నించండి',
                    booking_not_found: 'బుకింగ్ ఉనికిలో లేదు. అది తొలగించబడి ఉండవచ్చు',
                    generic: 'ఏదో తప్పు జరిగింది, పేజీని రిఫ్రెష్ చేయండి లేదా మమ్మల్ని సంప్రదించండి',
                },
                connection: {
                    connected: 'నిజ-సమయ నవీకరణలు',
                    connecting: 'రియల్ టైమ్ అప్‌డేట్‌లు కనెక్ట్ అవుతున్నాయి',
                    disconnected: 'నిజ-సమయ నవీకరణలు డిస్‌కనెక్ట్ చేయబడ్డాయి',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'హెచ్చరిక',
                    title: 'లాగ్అవుట్',
                    body: 'లాగ్ అవుట్ చేయడం వలన మీ కార్ట్‌కు జోడించబడిన ఏవైనా అంశాలు తీసివేయబడతాయి',
                    cancel: 'రద్దు చేయి',
                    proceed: 'కొనసాగండి',
                },
                order_restart: {
                    warning: 'హెచ్చరిక',
                    title: 'ఆర్డర్ వివరాలను మార్చండి',
                    body: 'మీ ఆర్డర్ వివరాలను మార్చడం వలన మీ కార్ట్‌లోని అంశాలు తీసివేయబడతాయి, ఎందుకంటే కొన్ని అంశాలు అందుబాటులో ఉండకపోవచ్చు',
                    cancel: 'రద్దు చేయి',
                    proceed: 'కొనసాగండి',
                },
                order_expired: {
                    subtitle: 'ముఖ్యమైనది',
                    title: 'ఆర్డర్ వెంటనే గడువుకు మార్చబడింది',
                    description: 'మీ ఆర్డర్ కోసం ఎంపిక చేసిన సమయం ఇప్పుడు దగ్గరలో ఉంది. అందువల్ల మీ ఆర్డర్‌ను వెంటనే / ASAP గా మార్చబడింది.',
                    button: 'సరే',
                },
                order_expiring: {
                    subtitle: 'ముఖ్యమైనది',
                    title: 'ఆర్డర్ గడువు త్వరలో ముగుస్తుంది',
                    description: 'మీ ఆర్డర్ తప్పనిసరిగా {{time, timeFromTimestamp}} కంటే ముందు ఉంచాలి లేకుంటే అది చెల్లుబాటు కాదు',
                    button: 'సరే',
                },
                location_permission: {
                    cancel: 'రద్దు చేయి',
                    proceed: 'కొనసాగండి',
                },
            },
            card_payment_authentication: {
                title: 'చెల్లింపు ప్రమాణీకరణ',
                note: 'దయచేసి మీరు మీ బ్యాంక్ నుండి ప్రామాణీకరణ ప్రక్రియను పూర్తి చేసే వరకు ఈ విండోను తెరిచి ఉంచండి.',
            },
            maps: {
                cancel: 'రద్దు చేయి',
                use_location: 'స్థానాన్ని ఉపయోగించండి',
            },
            app_refresh: {
                refresh: 'రిఫ్రెష్ చేయండి',
                title: 'రిఫ్రెష్ స్టోర్',
                description: 'మా స్టోర్‌లో అప్‌డేట్ జరిగింది. తాజా వెర్షన్‌ను యాక్సెస్ చేయడానికి దయచేసి మీ బ్రౌజర్‌ను రిఫ్రెష్ చేయండి. రిఫ్రెష్ చేసిన తర్వాత, చెకౌట్ ప్రక్రియను కొనసాగించడానికి మీ కార్ట్‌ను మళ్లీ తెరవాల్సి రావచ్చు.',
            },
        },
        sections: {
            nav_top: {
                guest: 'అతిథి',
                login: 'లాగిన్ చేయండి',
                login_signup: 'లాగిన్ / సైన్ అప్ చేయండి',
                logout: 'లాగ్అవుట్',
            },
            menus: {
                info: {
                    no_menus: 'ప్రస్తుతం మెనులు అందుబాటులో లేవు',
                    restrictions: 'మెను పరిమితులు',
                    not_available: 'మెను అందుబాటులో లేదు',
                    unavailable: {
                        times: "మెనూ అందుబాటులో లేదు, మీ ఆర్డర్ అవసరాలు క్రింద ఉన్న వాటితో సరిపోలడం లేదు.",
                        services: "మెనూ అందుబాటులో లేదు, మీ ఆర్డర్ అవసరాలు క్రింద ఉన్న వాటితో సరిపోలడం లేదు.",
                        hours: 'మెను అందుబాటులో లేదు, మీ ఆర్డర్ గంటలు ఈ మెనూలు అందుబాటులో ఉన్న గంటలలోపు కాదు',
                        pre_order: "మెనూ అందుబాటులో లేదు, మీ ఆర్డర్ ముందస్తు ఆర్డర్ అవసరాలకు సరిపోలడం లేదు.",
                        age: 'మెను అందుబాటులో లేదు, ఈ మెను నుండి ఆర్డర్ చేయడానికి మీరు తప్పనిసరిగా వయస్సు ధృవీకరించబడిన ఖాతాతో లాగిన్ అయి ఉండాలి',
                    },
                    services: {
                        title: 'ఆర్డర్ అవసరాలు',
                        pickup: 'పికప్‌లు',
                        delivery: 'డెలివరీలు',
                        dine_in: 'డైన్-ఇన్‌లు',
                    },
                    times: {
                        now: 'ముందస్తు ఆర్డర్‌లు లేవు',
                        later: 'ముందస్తు ఆర్డర్‌లు మాత్రమే',
                    },
                    hours: {
                        title: 'అందుబాటులో ఉన్న గంటలు',
                    },
                    preorder: {
                        title: 'ముందస్తు ఆర్డర్ అవసరాలు',
                        days_in_advance: '{{days}} రోజుల ముందుగా ఆర్డర్ చేయాలి',
                        cutoff_time: 'చివరి రోజు కట్-ఆఫ్ సమయం {{time, timeFromTime}}కి',
                    },
                    age_restricted: {
                        title: 'వయస్సు పరిమితం చేయబడింది',
                        approved: 'మీ ఖాతా ధృవీకరించబడింది మరియు మీరు ఈ మెను నుండి ఆర్డర్ చేయవచ్చు',
                        rejected: 'ఆర్డర్ చేయడానికి వయస్సు ధృవీకరణ అవసరం. ఖాతాను సృష్టించండి మరియు మీ IDని అప్‌లోడ్ చేయండి',
                    },
                },
                search: {
                    title: 'మెను ఐటెమ్‌లను అన్వేషించండి',
                    no_result: 'ఏదీ తిరిగి రాలేదు. మరొక శోధన పదాన్ని ప్రయత్నించాలా?',
                    placeholder: 'మీరు దేని కోసం చూస్తున్నారు?',
                },
            },
            category: {
                restrictions: 'వర్గం పరిమితులు',
                not_available: 'వర్గం అందుబాటులో లేదు',
                unavailable: {
                    services: "వర్గం అందుబాటులో లేదు, మీ ఆర్డర్ అవసరాలు క్రింద ఉన్న వాటితో సరిపోలడం లేదు.",
                    hours: "వర్గం అందుబాటులో లేదు, ఈ వర్గానికి అందుబాటులో ఉన్న సమయాల్లో మీ ఆర్డర్ సమయం లేదు.",
                },
            },
            info: {
                location: {
                    title: 'స్థానం',
                    view_map: 'మ్యాప్‌ని వీక్షించండి',
                    phone: 'ఫోన్',
                },
                hours: {
                    title: 'తెరిచే గంటలు',
                    title_special: 'ప్రత్యేక ప్రారంభ గంటలు',
                },
                services: {
                    title: 'సేవలు',
                    notes: 'గమనికలు',
                    delivery: {
                        ranges: 'డెలివరీ పరిధులు',
                        zones: 'డెలివరీ జోన్లు',
                        view_zones: 'మ్యాప్‌లో జోన్‌లను వీక్షించండి',
                        fee: 'డెలివరీ రుసుము',
                        fee_short: 'రుసుము',
                        fee_varies: 'మారుతూ ఉంటుంది, కార్ట్‌లో చూపబడింది',
                        min_order: 'కనీస ఆర్డర్',
                        min_order_short: 'కనీస ఆర్డ.',
                        no_min_order: 'కనీస ఆర్డర్ లేదు',
                        free_amount: 'ఉచిత డెలివరీ మొత్తం',
                    },
                },
            },
            contact: {
                title: 'మమ్మల్ని సంప్రదించండి',
                name: 'పేరు',
                email: 'ఇ-మెయిల్',
                phone: 'ఫోన్ నంబర్',
                message: 'మీ సందేశాన్ని నమోదు చేయండి...',
                send: 'సందేశం పంపండి',
                success: 'మీ సందేశం విజయవంతంగా పంపబడింది',
                error: 'ఏదో తప్పు జరిగింది, మళ్లీ ప్రయత్నించండి లేదా తర్వాత సమయంలో',
            },
            footer: {
                powered_by: 'ద్వారా ఆధారితం',
                terms_and_conditions: 'నిబంధనలు & షరతులు',
                privacy: 'గోప్యతా విధానం',
                cookie: 'కుకీ విధానం',
            },
        },
        pages: {
            payment_completed: {
                title: 'మీ చెల్లింపు ప్రాసెస్ చేయబడింది. మీ ఆర్డర్ కోసం ధన్యవాదాలు!',
                subtitle: 'ఆర్డర్ సమాచారం మీ ఇమెయిల్ చిరునామాకు పంపబడింది.',
                back_to_menu: 'తిరిగి మెనూకి',
                close_tab: 'ఈ ట్యాబ్‌ను మూసివేయండి',
            },
            payment_failed: {
                title: 'దురదృష్టవశాత్తూ మీ చెల్లింపును ప్రాసెస్ చేస్తున్నప్పుడు లోపం ఏర్పడింది.',
                subtitle: '',
                back_to_menu: 'తిరిగి మెనూకి',
                close_tab: 'ఈ ట్యాబ్‌ను మూసివేయండి',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'బుకింగ్ రసీదు',
            details: {
                datetime: 'కోసం బుకింగ్',
                number_of_people: 'ప్రజల సంఖ్య',
                placed: 'ఉంచబడింది',
                updated: 'చివరిగా నవీకరించబడింది',
                notes: 'గమనికలు',
                name: 'పేరు',
                email: 'ఇ-మెయిల్',
                phone: 'ఫోన్',
                store_address: 'స్టోర్ చిరునామా',
            },
            status_update: {
                title: 'బుకింగ్ {{number}} నవీకరించబడింది',
                body: 'మీ బుకింగ్ స్థితి {{status}}కి నవీకరించబడింది',
            },
            email_common: {
                name: 'పేరు: {{name}}',
                phone: 'ఫోన్: {{number}}',
                number_of_people: 'వ్యక్తుల సంఖ్య: {{number}}',
                date: 'తేదీ: {{date}}',
                time: 'సమయం: {{time}}',
                location: 'స్టోర్ స్థానం: {{name}}',
                notes: 'గమనికలు: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'కొత్త టేబుల్ బుకింగ్ {{number}} ద్వారా {{name}}',
                powered_by: '{{name}} ద్వారా ఆధారితం',
                overview: 'కొత్త టేబుల్ బుకింగ్ అభ్యర్థన',
                title: '{{name}} కోసం కొత్త బుకింగ్',
                subtitle: 'బుకింగ్ నంబర్ {{number}}',
                description_confirmed: 'బుకింగ్ ఆటోమేటిక్‌గా నిర్ధారించబడింది. మీరు దాన్ని అడ్మిన్ డాష్‌బోర్డ్ ద్వారా రద్దు చేయవచ్చు మరియు మీ కస్టమర్‌కు ఈమెయిల్ ద్వారా తెలియజేయబడుతుంది.',
                description_unconfirmed: 'దయచేసి నిర్వాహక డాష్‌బోర్డ్ ద్వారా బుకింగ్‌ను నిర్ధారించండి లేదా రద్దు చేయండి',
                url_pre_text: 'వద్ద వీక్షించండి మరియు నవీకరించండి',
            },
            email_new_booking_customer: {
                subject: 'టేబుల్ బుకింగ్ అభ్యర్థన',
                powered_by: '{{name}} ద్వారా ఆధారితం',
                overview: 'కొత్త టేబుల్ బుకింగ్ అభ్యర్థన',
                title: 'మీ బుకింగ్ కోసం ధన్యవాదాలు',
                subtitle: 'బుకింగ్ నంబర్ {{number}}',
                description: '<b>మీ బుకింగ్ నిర్ధారించబడింది లేదా రద్దు చేయబడింది అయినప్పుడు మీరు ఇమెయిల్ ద్వారా తెలుసుకోవచ్చు.</b><br>దయచేసి మీ బుకింగ్‌ను మార్చడానికి కాన్టాక్ట్ చేయండి. మీ బుకింగ్ వివరాలు క్రిందికి ఉన్నాయి:',
                url_pre_text: 'మీరు మీ నిజ-సమయ బుకింగ్ రసీదుని ఇక్కడ చూడవచ్చు',
            },
            email_update_booking_customer: {
                subject_confirmed: 'టేబుల్ బుకింగ్ నిర్ధారించబడింది',
                subject_unconfirmed: 'టేబుల్ బుకింగ్ రద్దు చేయబడింది',
                powered_by: '{{name}} ద్వారా ఆధారితం',
                overview: 'టేబుల్ బుకింగ్ అభ్యర్థన',
                title_confirmed: 'బుకింగ్ నిర్ధారించబడింది',
                title_unconfirmed: 'బుకింగ్ రద్దు చేయబడింది',
                subtitle: 'బుకింగ్ నంబర్ {{number}}',
                description_confirmed: 'మేము మిమ్మల్ని కలవడానికి ఎదురుచూస్తున్నాము. మీ బుకింగ్‌లో ఏవైనా మార్పులు కోరుకుంటే దయచేసి మమ్మల్ని సంప్రదించండి.',
                description_unconfirmed: 'మీ బుకింగ్ అభ్యర్థనను స్వీకరించలేకపోయామని తెలియజేయడానికి మేము చింతిస్తున్నాము. కలిగిన అసౌకర్యానికి క్షమించండి. మీకు ఏవైనా ప్రశ్నలు ఉంటే దయచేసి మమ్మల్ని సంప్రదించండి.',
                url_pre_text: 'మీరు మీ నిజ-సమయ బుకింగ్ రసీదుని ఇక్కడ చూడవచ్చు',
            },
            email_status_update_customer: {
                subject: 'బుకింగ్ #{{number}} – {{subjectLabel}}',
                body: '{{store}} వద్ద మీ బుకింగ్ #{{number}} ఇప్పుడు {{status}}.',
            },
            errors: {},
            status_warning: 'బుకింగ్‌ల పేజీలోని మీ అడ్మిన్ డ్యాష్‌బోర్డ్‌లో ఈ బుకింగ్ స్థితిని అప్‌డేట్ చేయండి',
        },
    },
    email_delayed_order: {
        subject: 'ఆర్డర్ #{{number}} – {{subjectLabel}}',
        header: 'నవీకరించిన సిద్ధం అయ్యే సమయం',
        title: 'నవీకరించిన సిద్ధం అయ్యే సమయం',
        order_number: 'ఆర్డర్ సంఖ్య: {{number}}',
        description: 'మీ ఆర్డర్ ఇప్పుడు {{time}}కి సిద్ధమవుతుంది.',
        order_time_updated_to: 'మీ ఆర్డర్ సమయం నవీకరించబడింది.',
        powered_by: '{{name}} ద్వారా ఆధారితం',
        button_text: 'ఆర్డర్‌ను ట్రాక్ చేయండి',
        subject_label: 'నవీకరించిన సిద్ధం అయ్యే సమయం',
        subject_label_delivery: 'నవీకరించిన డెలివరీ సమయం',
        body_ready: 'మీ ఆర్డర్ ఇప్పుడు {{time}}కి సిద్ధమవుతుంది.',
        body_delivery: 'మీ ఆర్డర్ ఇప్పుడు {{time}}కి డెలివరీ అవుతుంది.',
    },
    order: {
        receipt: {
            est_ready_time: 'అంచనా. రెడీ టైమ్',
            est_driver_pickup_time: 'అంచనా. డ్రైవర్ పికప్ సమయం',
            est_delivery_time: 'అంచనా. డెలివరీ సమయం',
            tab_details: 'వివరాలు',
            tab_dishes: 'వస్తువులు',
            future_order: 'ఫ్యూచర్ ఆర్డర్',
            reprint: 'రీప్రింట్',
            details: {
                order_no: 'ఆర్డర్ నం.',
                status: 'స్థితి',
                placed: 'ఉంచబడింది',
                due: 'కారణంగా',
                due_asap: 'ఇప్పుడు / ASAP',
                last_updated: 'చివరిగా నవీకరించబడింది',
                total: 'మొత్తం',
                type: 'టైప్ చేయండి',
                origin: 'మూలం',
                table: 'పట్టిక',
                number_of_people: 'వ్యక్తుల సంఖ్య',
                payment_method: 'చెల్లింపు విధానం',
                payment_status: 'చెల్లింపు స్థితి',
                payment_currency: 'చెల్లింపు కరెన్సీ',
                notes: 'గమనికలు',
                name: 'పేరు',
                email: 'ఇ-మెయిల్',
                phone: 'ఫోన్',
                distance: 'దూరం',
                driving_time: 'డ్రైవింగ్ సమయం',
                delivery_zone: 'జోన్',
                delivery_address: 'డెలివరీ చిరునామా',
                delivery_provider: 'డెలివరీ ప్రొవైడర్',
                delivery_tracking: 'డెలివరీ ట్రాకింగ్',
                delivery_return_tracking: 'ట్రాక్ రిటర్న్',
                delivery_tracking_link: 'ఆర్డర్‌ను ట్రాక్ చేయండి',
                tookan_status: 'టూకాన్ స్థితి',
                tookan_status_failed_book: 'బుక్ డెలివరీ చేయడంలో విఫలమైంది',
                tookan_status_failed_update: 'బుకింగ్‌ను అప్‌డేట్ చేయడంలో విఫలమైంది',
                tookan_status_success: 'డెలివరీ కోసం బుక్ చేయబడింది',
                store_address: 'స్టోర్ చిరునామా',
                destination: 'గమ్యం',
                estimated_arrival_time: 'రాక సమయాన్ని అంచనా వేయండి',
                delivery_status: 'స్థితి',
                delivery_track_your_order: 'మీ ఆర్డర్‌ని ట్రాక్ చేయండి',
                delivery_text: 'డెలివరీ',
                arrival_date: 'రాక తేదీ',
            },
            dishes: {
                headings: {
                    quantity: 'క్యూటీ',
                    item: 'అంశం',
                    price: 'ధర',
                },
                notes: 'గమనికలు',
                remove_ingredients: 'పదార్ధాలను తొలగించండి',
            },
            status_update: {
                title: 'ఆర్డర్ {{number}} నవీకరించబడింది',
                body: 'మీ ఆర్డర్ స్థితి {{status}}కి నవీకరించబడింది',
            },
            wait_time_update: {
                title: 'ఆర్డర్ {{number}} నవీకరించబడింది',
                body: 'మీ ఆర్డర్ గడువు సమయం నవీకరించబడింది',
            },
            delivery_update: {
                title: 'ఆర్డర్ {{number}} నవీకరించబడింది',
                body: 'మీ ఆర్డర్ డెలివరీ కోసం బుక్ చేయబడింది. నిజ-సమయ ట్రాకింగ్ లింక్‌ని చూడండి',
            },
            payment_status_update: {
                title: 'ఆర్డర్ {{number}} నవీకరించబడింది',
                body: 'మీ ఆర్డర్ చెల్లింపు స్థితి నవీకరించబడింది.',
            },
            email_new_order_restaurant: {
                subject: 'కొత్త ఆర్డర్ ({{number}}) - {{name}}',
                powered_by: '{{name}} ద్వారా ఆధారితం',
                overview: 'కొత్త ఆర్డర్ నోటిఫికేషన్',
                title: 'కొత్త ఆర్డర్ {{name}}లో ఉంచబడింది',
                subtitle: 'ఆర్డర్ నంబర్ {{number}}',
                description: 'మీ అడ్మిన్ డాష్‌బోర్డ్ ద్వారా వివరాలు మరియు అప్‌డేట్‌లను వీక్షించండి',
                button_text: 'ఆర్డర్‌ను ట్రాక్ చేయండి',
                track_delivery_button_text: 'డెలివరీని ట్రాక్ చేయండి',
            },
            email_new_order_customer: {
                subject: 'ఆర్డర్ రసీదు ({{number}})',
                powered_by: '{{name}} ద్వారా ఆధారితం',
                overview: 'కొత్త ఆర్డర్ నోటిఫికేషన్',
                title: 'కొత్త ఆర్డర్ {{name}}లో ఉంచబడింది',
                subtitle: 'ఆర్డర్ నంబర్ {{number}}',
                description: 'మీ నిజ-సమయ ఆన్‌లైన్ రసీదు ద్వారా వివరాలను మరియు నవీకరణలను వీక్షించండి',
                button_text: 'ఆర్డర్‌ను ట్రాక్ చేయండి',
                track_delivery_button_text: 'డెలివరీని ట్రాక్ చేయండి',
            },
            email_order_completed_by_customer: {
                subject: 'ఆర్డర్ ({{number}}) కస్టమర్ ద్వారా పూర్తి చేయబడింది',
                powered_by: '{{name}} ద్వారా ఆధారితం',
                overview: 'ఆర్డర్ పూర్తయిన నోటిఫికేషన్',
                title: 'ఆర్డర్ {{name}}కి పూర్తయింది',
                subtitle: 'ఆర్డర్ నంబర్ {{number}}',
                description: 'మీ డ్యాష్‌బోర్డ్ ద్వారా లేదా రసీదుని ఉపయోగించి మీ ఆర్డర్ వివరాలను వీక్షించండి మరియు నవీకరించండి',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. ధరలో',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'డెలివరీ రుసుము',
            delivery_fee_offset: 'డెలివరీ రుసుము తగ్గింపు',
            delivery_fee_total: 'డెలివరీ ఫీజు మొత్తం',
            promo: 'తగ్గింపు: {{name}} ({{value, currency}} + {{percent}}% తగ్గింపు)',
            promo_percent: 'తగ్గింపు: {{name}} ({{percent}}%)',
            promo_fixed: 'తగ్గింపు: {{name}}',
            promo_none: 'తగ్గింపు: {{name}}',
            cart: 'బండి',
            tip: 'ఆర్డర్ చిట్కా',
            total: 'మొత్తం',
        },
        status: {
            unconfirmed: 'ధృవీకరించబడలేదు',
            awaiting_payment: 'చెల్లింపు కోసం వేచి ఉంది',
            confirmed: 'నిర్ధారించారు',
            ready: 'సిద్ధంగా ఉంది',
            on_route: 'మార్గంలో',
            complete: 'పూర్తి',
            cancelled: 'రద్దు చేయబడింది',
            seated: 'కూర్చోబెట్టబడింది',
        },
        searching: {
            lalamove_search_placeholder: 'లాలామోవ్ డెలివరీ ID ద్వారా ఆర్డర్‌ను శోధించండి',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'అందుబాటులో లేదు',
                },
            },
            dish: {
                no_stock: 'స్టాక్ అయిపోయింది',
                not_available: 'అందుబాటులో లేదు',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'ఇ-మెయిల్ నిర్ధారణ కోడ్',
            register_confirmation_code_email: 'మీ ఇమెయిల్ నిర్ధారణ కోడ్ {{confirmation_code}} (24 గంటల్లో గడువు ముగుస్తుంది)',
            register_confirmation_code_email_onbehalf: 'మీ ఇమెయిల్ నిర్ధారణ కోడ్ {{confirmation_code}} (24 గంటల్లో గడువు ముగుస్తుంది). ఇది ఇమెయిల్ చిరునామా, {{email}} కొరకు ఉంది.',
        },
    },
};
//# sourceMappingURL=te.js.map